export const RetiroPendientes =[
    {
      Header: "No. de Guía",
      accessor: "Guia"
    },
    {
      Header: "Estado",
      accessor: "Estado"
    },
    {
        Header: "Tienda",
        accessor: "Tienda"
    },
    {
      Header: "casilla",
      accessor: "Recepcion"
  },
    {
      Header: "Descripcion",
      accessor: "Descripcion"
    },
    {
      Header: "Peso (kgs)",
      accessor: "Peso"
    },
    {
      Header: "Valor FOB (USD)",
      accessor: "Fob"
    },
    {
      Header:"Imagenes",
      accessor:"Imagen1",
    },
    {
      Header: "Fecha Recepcion",
      accessor: "Fecha_recepcion_miami"
    }
  ];


  export const RetiroInicial={
    Guiahija:"-",
    DescripcionEgeo:"-",
    proveedor:"-",
    descripcionProducto:"-",
    Peso_Efectivo:"-",
    Valor_Fob:"-",
    Fecha_recepcion_miami:"-"
  }